import React, {Component} from 'react';
import IgniteDataTable from '../../../common/datatable';
import {history} from '../../../../store';
import {dateTimeFormatUK} from '../../../../utils/commonFunctions';
import t from '../../../../data/translations';

class RedemptionsList extends Component {
  render() {
    const columns = [
      {
        prop: 'customer-number',
        title: 'Customer number',
        width: '100',
        onClick(data, row) {
          history.push(`/admin/outlets/${row.attributes['outlet-id']}/view`);
        }
      },
      {
        prop: 'redemption-date',
        title: 'Redemption date',
        format(data) {
          return (
            <b>
              {dateTimeFormatUK(data)}
            </b>
          );
        }
      },
      {
        prop: 'voucher-type',
        title: 'Voucher type',
      },
      {
        prop: 'points',
        title: 'Value (points)',
        width: '100'
      },
      {
        prop: 'euro',
        title: `Value (${t('currency')})`,
        width: '100'
      },
      {
        prop: 'auto-redemption',
        title: 'Auto redemption?',
        width: '100',
        format(data) {
          return data ? 'Y' : 'N';
        }
      },
      {
        prop: 'user-id',
        title: 'User ID',
        width: '100',
        render(data, row) {
          return !row.attributes['auto-redemption'];
        },
        onClick(data) {
          history.push(`/admin/users/${data}/details`);
        }
      },
      {
        prop: 'username',
        title: 'Name of Orderer',
        render(data, row) {
          return !row.attributes['auto-redemption'] && row.attributes['name-of-orderer-first'] && row.attributes['name-of-orderer-last'];
        },
        format(data, row) {
          return `${row.attributes['name-of-orderer-first']} ${row.attributes['name-of-orderer-last']}`;
        }
      },
      {
        prop: 'email-address',
        title: 'Email address',
        render(data, row) {
          return !row.attributes['auto-redemption'];
        }
      },
    ];
    return (
      <IgniteDataTable
        columns={columns}
        data={this.props.redemptions}
        dataSize={this.props.paging.number * this.props.paging.size}
        hideId={false}
        pagination={{
          page: this.props.currentPage,
          sizePerPage: 20,
          onPageChange: this.props.onPageChange,
        }}
        remote
      />
    );
  }
}

export default RedemptionsList;



// WEBPACK FOOTER //
// ./src/components/admin/staff-reward/redemptions/redemptions-list.jsx